import React, { useState, useEffect } from 'react'
import './style.css'
import { unByKey } from 'ol/Observable';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';

const KEY_LAYERS = 'key_layers'

const LayersComponent = (props) => {

    const [reload, setReload] = useState(true)

    useEffect(() => {
        props.layersToShow(props.layers.filter(l => l.visible));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.layers])

    const handleUIStateChanged = async (event, layerId) => {
        const { checked } = event.target;
        const layer = props.layers.filter(l => l.layer.id === layerId)[0]
        layer.visible = checked
        if (checked && !layer.layer.olLayer.get(KEY_LAYERS)) {
            layer.loading = true
            listenerChange(layer)
        }

        props.layersToShow(props.layers.filter(l => l.visible));
    }

    const listenerChange = (layer) => {
        const listenerKey = layer.layer.olLayer.getSource().on('change', event => {
            setLoadingFalse(layer)
            unByKey(listenerKey);
        });
    }

    const setLoadingFalse = (layer) => {
        layer.loading = false
        setReload(!reload)
    }

    const layersDivs = props.layers
        .filter(layerUIState => !layerUIState.ocultarCamada)
        .map(layerUIState => {
            return (
                <div key={`layer_${layerUIState.layer.id}`} style={{ display: "flex", alignItems: "center" }}>
                    {/* <input type="checkbox"
                    defaultChecked={layerUIState.visible}
                    onClick={(event) => handleUIStateChanged(event, layerUIState.layer.id)}
                />
                &nbsp;{layerUIState.layer.name}{layerUIState.loading ? '*' : ''} */}


                    <FormControlLabel
                        style={{ marginTop: -5, marginBottom: -5, marginRight: 8 }}
                        control={
                            <Checkbox
                                onChange={(event, value) => handleUIStateChanged(event, layerUIState.layer.id)}
                                color="default"
                                value={layerUIState.layer.name}
                                inputProps={{
                                    'aria-label': 'checkbox with default color',
                                }}
                            />
                        }
                        label={<label style={{ fontFamily: "sans-serif", fontSize: 14 }}>{layerUIState.layer.name}</label>}
                    />
                    {layerUIState.loading && (
                        <CircularProgress disableShrink color="inherit" size={16} style={{ color: "#0b7e7a" }} />
                    )}
                </div>
            )
        });

    return (
        <div className={props.className}>
            {layersDivs}
        </div>
    )
}

export default LayersComponent